import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { effectiveEntityRightQueryDocument } from "./entity-permission.gql";

export interface UseEffectiveEntityRightProps {
  entityId: string;
  entityType: string;
  workspaceId: string;
  enabled?: boolean;
  useKeepPreviousData?: boolean;
}

export const useEffectiveEntityRight = ({
  entityId,
  entityType,
  workspaceId,
  enabled = true,
  useKeepPreviousData = false,
}: UseEffectiveEntityRightProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.entityPermissions.effectiveRight(entityId, entityType, workspaceId),
    queryFn: async () => {
      const client = createOperationClient("effectiveEntityRight");
      const data = await client.request(effectiveEntityRightQueryDocument, {
        input: { entityId, entityType, workspaceId },
      });

      return data.effectiveEntityRight;
    },
    enabled: enabled && !!entityId && !!entityType && !!workspaceId,
    placeholderData: useKeepPreviousData ? keepPreviousData : undefined,
    staleTime: 5 * 60 * 1000,
  });

  return {
    effectiveRight: queryResult.data ?? null,
    loading: queryResult.isLoading,
    error: queryResult.error,
  };
};
